import { FormattedMessage } from "react-intl";
import { displayPopin } from "../../Hook/popins";
import { useResolvedMode } from "../../Hook/theme";
import { AdsBannerProps } from "./config";
import AdTile from "./AdTile";

/**
 * Family B, age verification (2d): the pale blue tile ships as the light pair;
 * dark inverts it — the gradient goes deep, the ink copy goes white, and the
 * CTA keeps #123563 as its text on a white pill. This is the one gate: no
 * dismiss, it stays until the account is verified.
 */
const MODES = {
  light: {
    tile: "border border-[#dde8ff] bg-gradient-to-r from-[#e8f0ff] via-[#d9ebff] to-[#c8e5ff] shadow-[0_18px_40px_rgba(56,119,191,0.22)]",
    kicker: "text-[#21538c]/80",
    title: "text-[#123563]",
    body: "text-[#184271]/90",
    cta: "bg-[#123563] text-white",
  },
  dark: {
    tile: "border border-[#1a4a80] bg-gradient-to-r from-[#0d2647] via-[#123563] to-[#17427a] shadow-[0_18px_40px_rgba(9,30,58,0.5)]",
    kicker: "text-white/70",
    title: "text-white",
    body: "text-white/80",
    cta: "bg-white text-[#123563]",
  },
};

function UnderageVerificationBanner(_props: AdsBannerProps) {
  const display = displayPopin();
  const tones = MODES[useResolvedMode()];

  return (
    <AdTile testId="ad-underage" onOpen={() => display("underage")} className={tones.tile}>
      <div className="flex-1 min-w-0">
        <p className={"text-[10px] uppercase tracking-[0.3em] truncate " + tones.kicker}>
          <FormattedMessage id="ads_underage_kicker" defaultMessage="Safe access" />
        </p>
        <h3 className={"text-base sm:text-xl font-black leading-tight truncate " + tones.title}>
          <FormattedMessage
            id="ads_underage_title"
            defaultMessage="Verify your age and unlock explicit content"
          />
        </h3>
        <p className={"text-xs truncate hidden sm:block " + tones.body}>
          <FormattedMessage
            id="ads_underage_body"
            defaultMessage="Quick, secure verification in under 2 minutes."
          />
        </p>
      </div>
      <div
        className={
          "flex-none inline-flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-xs sm:text-sm font-bold leading-none shadow-sm " +
          tones.cta
        }
      >
        <FormattedMessage id="ads_underage_cta" defaultMessage="Verify now" />
        <span aria-hidden>→</span>
      </div>
    </AdTile>
  );
}

export default UnderageVerificationBanner;
